function deepAssign(source){
    if(Array.isArray(source)){
        let dest = [];

        for(let i = 0; i < source.length; i++){
            dest[i] = deepAssign(source[i]);
        }

        return dest;
    }

    if(typeof source === "object" && source){
        let dest = Object.assign({}, source);

        for(let property in source){
            if ({}.hasOwnProperty.call(source, property)){
                dest[property] = deepAssign(source[property]);
            }
        }

        return dest;
    }

    return source;
}

function today(){
    let date = new Date(Date.now());

    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();

    return new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
}

function addDays(date, days){
    date.setDate(date.getDate() + days);
}

function stripTimeFromDateString(dateString){
    let date = new Date(dateString);

    let day = date.getDate() + "";
    if(day.length == 1){
        day = "0" + day;
    }
    let month = (date.getMonth() + 1) + "";
    if(month.length == 1){
        month = "0" + month;
    }
    let year = date.getFullYear();

    return year + "-" + month + "-" + day;
}

function sortByField(field, forceLast) {
    return function(a, b) {
        // if the value is the string "other"
        if (forceLast && forceLast.length > 0) {
            for (let i=0; i<forceLast.length; i++) {
                let target = forceLast[i];

                if (a[field] === target) {
                    return 1;
                }
    
                if (b[field] === target) {
                    return -1;
                }
            }
        }

        if (a[field] < b[field]) {
            return -1;
        }
        else if (a[field] > b[field]) {
            return 1;
        }
    
        return 0;
    }
}

function sortByName(a, b) {
    if (a.Name < b.Name) {
        return -1;
    }
    else if (a.Name > b.Name) {
        return 1;
    }

    return 0;
}

function getUserProfileFromUserObject(userObject) {
    if (userObject && userObject.UserProfile) {
        return userObject.UserProfile;
    }
    
    return null;
}

function getUserProfileNameFromUserObject(userObject) {
    let userProfile = getUserProfileFromUserObject(userObject);

    if(userProfile) {
        if(userProfile.FirstName && userProfile.LastName) {
            return userProfile.FirstName + " " + userProfile.LastName;
        }

        if(userProfile.FirstName) {
            return userProfile.FirstName;
        }

        if(userProfile.LastName) {
            return userProfile.LastName;
        }
    }

    return null;
}

export default {
    deepAssign: deepAssign,
    today,
    addDays,
    stripTimeFromDateString,
    sortByName,
    sortByField,
    getUserProfileFromUserObject,
    getUserProfileNameFromUserObject
};
